export const forceRefreshDataGridTable = () => {
  document.getElementById('data-grid-refresh-button')?.click();
};
